import { ArrowLeftOutlined, ArrowUpOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  FloatButton,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
  Upload,
  message,
  theme,
  
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { useCallback, useEffect,useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { APPCONFIG } from "../../../Config";
import Heading from "../../../components/common/heading";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import { ACCESS_TOKEN, SUCCESS_CODE } from "../../../lib/const";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import { routes } from "../../../routes";
import {
  createFutureCustomer,
  getDropDownCountry,
  getDropDownMaster,
  getDropDownVOC,
  getFutureCustomer,
  updateFutureCustomer,
} from "../../../services/customerFutures";
import APIEndpoint from "../../../services/endpoint";
import WithSidebar from "../../../templates/withSidebar";
import {
  Years,
  masterDataFuture,
  onDecimalChange,
  vocDataFuture,
} from "../../customer/touchpoint/components/dataReport";
import { downloadFile } from "../../../services/uploadFile";

import Behavior from "./components/create/behavior";
import Contact from "./components/create/contact";
import FutureDetail from "./components/create/futureDetail";
import VoiceOfCustomer from "./components/create/voiceOfCustomer";
import useYearList from "../../../lib/hooks/useYearsList";
import useContactReason from "../../../lib/hooks/useContactReason";
import {
  searchListByCompany,
} from "../../../services/customerFutures";
// import lodash
import _, { result } from "lodash";

const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

export const convertMasterData = (keytext, data) => {
  let text = "";
  data.map((Item) => {
    if (Item.dataId === keytext) {
      text = Item.dataDetailTh;
    }
  });
  return text;
};

export const AddFutureCustomer = () => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [optionsYear, setOptionYear] = useState(Years);
  const [actionType, setActionType] = useState(
    location.state.action_type ? location.state.action_type : ""
  );
  const [channel,setChannel] = useState(
    location.state.channel ? location.state.channel : ""
  );
  const [actionName, setActionName] = useState("เพิ่มสิทธิ์");

  const [otherTopicDefined, setOtherTopicDefined] = useState(false);

  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [id, setId] = useState(location.state.id ? location.state.id : "");
  const [dataDetail, setDataDetail] = useState([]);
  const [yearList] = useYearList();
  const [dropDownContactReason] = useContactReason();

  const [dropDownCountry, setDropDownCountry] = useState([]);
  const [dropDownMaster, setDropDownMaster] = useState([]);
  const [dropDownVOC, setDropDownVOC] = useState([]);
  const [dropDownCurerntStatus, setDropDownCurerntStatus] = useState([]);
  const [dropDownCompanyType, setDropDownCompanyType] = useState([]);
  const [dropDownIndustryType, setDropDownIndustryType] = useState([]);
  const [dropDownAreaType, setDropDownAreaType] = useState([]);
  const [dropDownKnowChannel, setDropDownKnowChannel] = useState([]);
  const [dropDownFutureEstate, setDropDownFutureEstate] = useState([]);
  const [dropDownRegionGroup, setDropDownRegionGroup] = useState([]);
  const [dropDownRegionType, setDropDownRegionType] = useState([]);
  const [dropDownPurpost, setDropDownPurpost] = useState([]);

  const [dropDownproductRequirement, setDropDownProductRequirement] = useState(
    []
  );
  const [dropDowncustomerSupport, setDropDownCustomerSupport] = useState([]);
  const [dropDowncustomerExpact, setDropDownCustomerExpact] = useState([]);
  const [dropDownbusinessRequire, setDropDownbusinessRequire] = useState([]);
  const [dropDownotherProductExpect, setDropDownotherProductExpect] = useState(
    []
  );
  const [dropDownotherSupportExpect, setDropDownSupportExpect] = useState([]);
  const [dropDownotherBusinessExpect, setDropDownBusinessExpect] = useState([]);

  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });

  const [productRequirement, setProductRequirement] = useState({
    type: "product_requirement",
    detail: [],
  });
  const [customerSupport, setCustomerSupport] = useState({
    type: "customer_support",
    detail: [],
  });
  const [customerExpact, setCustomerExpact] = useState({
    type: "customer_expect",
    detail: [],
  });
  const [businessRequire, setbusinessRequire] = useState({
    type: "business_require",
    detail: [],
  });
  const [otherProductExpect, setotherProductExpect] = useState({
    type: "other_product_expect",
    detail: [],
  });
  const [otherSupportExpect, setSupportExpect] = useState({
    type: "other_support_expect",
    detail: [],
  });
  const [otherBusinessExpect, setBusinessExpect] = useState({
    type: "other_business_expect",
    detail: [],
  });
  const [otherExpect, setOtherExpect] = useState({
    type: "other_expect",
    detail: [],
  });

  const [behaviorChannel, setBehaviorChannel] = useState([]);

  const [datesRange, setDatesRange] = useState(null);
  const [valueRange, setValueRange] = useState(null);

  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();

  const [yearOfBudget, setYearOfBudget] = useState();
  const [contactReason, setContactReason] = useState();
  const [currentStatus, setCurrentStatus] = useState();

  const [companyType, setCompanyType] = useState();
  const [industryTypeIds, setIndustryTypeIds] = useState([]);
  const [nationalIds, setNationalIds] = useState();
  const [areaTypeIds, setAreaTypeIds] = useState();
  const [estateTypeIds, setEstateTypeIds] = useState();
  const [regionTypeIds, setRegionTypeIds] =useState();
  const [contactList, setContactList] = useState([]);

  const [resultVOCData, setResultVOCData] = useState([]);

  const [tableListData, setTableListData] = useState([]);
  const [statusBT, setStatusBT] = useState(false);

  const [file, setFile] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [fileImageList, setFileImageList] = useState([]);
  const [errMgeFile, setErrMgeFile] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [records,setRecords] = useState([]);

  const [defaultFile, setDefaultFile] = useState([]);
  const [countMonth, setCounthMonth] = useState(0);
  const [companyAutocomplete,setCompanyAutocomplete] = useState();
  const [preview, setPreview] = useState({ visible: false, src: "", isPdf: false, title: "" });
  

  const onCalculatorMonth = (date, dateString) => {
    const d_now = new Date();
    const getDate = (date) => moment(date, "DD/MM/YYYY").startOf("month");
    const diff = Math.abs(getDate(dateString).diff(getDate(d_now), "months"));
    setCounthMonth(diff);
  };

  const getVOC = useCallback(
    async (toppicKey) => {
      const res = await getDropDownVOC(toppicKey);
      if (res.data.code === "0000") {
        let result_data = res.data.objectValue;

        // if (toppicKey == "product_requirement") {
        //   setDropDownProductRequirement(result_data);
        // } else if (toppicKey == "customer_support") {
        //   setDropDownCustomerSupport(result_data);
        // } else if (toppicKey == "business_require") {
        //   setDropDownbusinessRequire(result_data);
        // } else if (toppicKey == "customer_expect") {
        //   setDropDownCustomerExpact(result_data);
        // } else if (toppicKey == "other_product_expect") {
        //   setDropDownotherProductExpect(result_data);
        // } else if (toppicKey == "other_support_expect") {
        //   setDropDownSupportExpect(result_data);
        // } else if (toppicKey == "other_business_expect") {
        //   setDropDownBusinessExpect(result_data);
        // }
        if (toppicKey == "future_product_require") {
          setDropDownProductRequirement(result_data);
        } else if (toppicKey == "future_customer_support") {
          setDropDownCustomerSupport(result_data);
        } else if (toppicKey == "future_business_require") {
          setDropDownbusinessRequire(result_data);
        } else if (toppicKey == "future_customer_expect") {
          setDropDownCustomerExpact(result_data);
        } else if (toppicKey == "future_other_product_expect") {
          setDropDownotherProductExpect(result_data);
        } else if (toppicKey == "future_other_support_expect") {
          setDropDownSupportExpect(result_data);
        } else if (toppicKey == "future_other_business_expect") {
          setDropDownBusinessExpect(result_data);
        }
      }
    },
    [dropDownVOC]
  );

  const getCountry = useCallback(async () => {
    try {
      const res = await getDropDownCountry();

      if (res.data.code === "0000") {
        let result_data = res.data.objectValue;
        setDropDownCountry(result_data);
      }
    } catch (error) {
      // console.log("error==>", error);
    }
  }, [dropDownCountry]);

  const getMaster = useCallback(
    async (toppicKey) => {
      try {
        const res = await getDropDownMaster(toppicKey);
        if (res.data.code === "0000") {
          let result_data = res.data.objectValue;

          if (toppicKey == "current_status_v2") {
            setDropDownCurerntStatus(result_data);
          } else if (toppicKey == "company_type") {
            setDropDownCompanyType(result_data);
          } else 
            // if (toppicKey == "industry_type") {
            // setDropDownIndustryType(result_data);
            if (toppicKey == "future_industry_type") {
            setDropDownIndustryType(result_data);
          } else 
            // if (toppicKey == "area_type") {
            // setDropDownAreaType(result_data);
            if (toppicKey == "future_area_type") {
            setDropDownAreaType(result_data);
          } else if (toppicKey == "known_channel") {
            setDropDownKnowChannel(result_data);
          } else if (toppicKey == "future_estate_type") {
            setDropDownFutureEstate(result_data);
          } else if (toppicKey == "region_group") {
            setDropDownRegionGroup(result_data);
          } else if (toppicKey == "region_type") {
            setDropDownRegionType(result_data);
          } else if (toppicKey == "purpose_contact") {
            setDropDownPurpost(result_data);
          }
        }
      } catch (error) {
        // console.log("error==>", error);
      }
    },
    [dropDownMaster]
  );

  const disabledDate = (current) => {
    if (!datesRange) {
      return false;
    }
    const tooLate = datesRange[0] && current.diff(datesRange[0], "days") >= 20;
    const tooEarly = datesRange[1] && datesRange[1].diff(current, "days") >= 20;
    return tooEarly || tooLate;
  };

  const onChangePage = () => {
    setOpenCancelModal(true);
  };

  const onChangesetYearOfBudget = (value) => {
    setYearOfBudget(value);
  };

  const onChangeContactReason = (value) => {
    setContactReason(value);
  };

  const onChangeCurrentStatus = (value) => {
    setCurrentStatus(value);
  };

  const onChangeCompanyType = (value) => {
    setCompanyType(value);
  };

  const onChangeIndustryTypeIds = (value) => {
    // console.log("value onChangeIndustryTypeIds", value);
    // const arr = [value];
    setIndustryTypeIds([value]);
  };

  const onChangeNationalIds = (value) => {
    setNationalIds([value]);
  };

  const onChangeAreaTypeIds = (value) => {
    setAreaTypeIds(value);
  };
  const onChangeFutureEstate = (value) =>{
    setEstateTypeIds(value);
  }
  const onChangeRegionType = (value) =>{
    setRegionTypeIds(value);
  }
  if(actionType === "CREATE" && channel){
    form.setFieldsValue({dropDownKnowChannel:channel})
  }
  const handleOnChangeVOC = (value, type) => {
    // console.log("v", value);
    // console.log("t", type);

    if (type === "productRequirement") {
      setProductRequirement({
        type: "product_requirement",
        detail: value,
      });
    } else if (type === "customerSupport") {
      setCustomerSupport({
        type: "customer_support",
        detail: value,
      });
    } else if (type === "customerExpact") {
      setCustomerExpact({
        type: "customer_expect",
        detail: value,
      });
    } else if (type === "businessRequire") {
      setbusinessRequire({
        type: "business_require",
        detail: value,
      });
    } else if (type === "otherProductExpect") {
      setotherProductExpect({
        type: "other_product_expect",
        detail: value,
      });
    } else if (type === "otherSupportExpect") {
      setSupportExpect({
        type: "other_support_expect",
        detail: value,
      });
    } else if (type === "otherBusinessExpect") {
      setBusinessExpect({
        type: "other_business_expect",
        detail: value,
      });
    } else if (type === "otherExpect") {
      setOtherExpect({
        type: "other_expect",
        detail: value,
      });
    } else if (type === "dropDownKnowChannel") {
      setBehaviorChannel(value);
    }
  };

  //TABLE FUNCTION
  const [dataSource, setDataSource] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [count, setCount] = useState(0);
  const [tableAction, settableAction] = useState(false);
  const [chkFirst, setChkFirst] = useState(true);

  const handleAdd = () => {
    settableAction(false);

    form.setFieldsValue({
      name: "",
      position: "",
      phones: [],
      emails: [],
      favorite : false,

    });

    if (actionType === "EDIT") {
      if (chkFirst) {
        const newData = {
          key: count + dataSource.length,
          sequence: count + dataSource.length + 1,
          name: "",
          position: "",
          phones: [],
          emails: [],
        };
        setDataSource((pre) => {
          return [...pre, newData];
        });
        setCount(count + dataSource.length + 1);
        setEditingRow(count + dataSource.length);
        setChkFirst(false);
      } else {
        const newData = {
          key: count,
          sequence: count + 1,
          name: "",
          position: "",
          phones: [],
          emails: [],
        favorite : false,

        };
        setDataSource((pre) => {
          return [...pre, newData];
        });
        setCount(count + 1);
        setEditingRow(count);
      }
    } else {
      const newData = {
        key: count,
        sequence: count + 1,
        name: "",
        position: "",
        phones: [],
        emails: [],
        favorite : false,
      };
      setDataSource((pre) => {
        return [...pre, newData];
      });
      setCount(count + 1);
      setEditingRow(count);
    }

    //check limit add
    if (dataSource.length >= 9) {
      setStatusBT(true);
    } else {
      setStatusBT(false);
    }
  };

  const handleEdit = (record) => {
    settableAction(false);

    setEditingRow(record.key);

    form.setFieldsValue({
      key: record.key,
      name: record.name,
      position: record.position,
      phones: record.phones,
      emails: record.emails,
      favorite : record.favorite
    });
  };

  const handleDeleteReccord = (record) => {
    setDataSource((pre) => {
      return pre.filter((table) => table.key != record.key);
    });

    if (dataSource.length < 11) {
      setStatusBT(false);
    } else {
      setStatusBT(true);
    }
    setCount(count - 1);
    setEditingRow(null);
  };
  const handleFavorite = (record) => {
    const currentRow = dataSource.find(row => row.key === record.key);

        setDataSource((prev) =>
            prev.map((row) => {
                if (row.key === record.key) {
                    const newFavorite = row.favorite === true ? false : true;
                    let result_f = { ...row, favorite: newFavorite };
                    console.log('result ',result_f);
                    return result_f
                }
                let result_f = { ...row, favorite: false };
                console.log('result ',result_f);

                return result_f;
            })
        );
        
        console.log('DataSource : ',dataSource);

    };
  const onSaveTable = async (values) => {
    const currentRow = dataSource.find(row => row.key === values.key);
    console.log('onsave : ',form.getFieldsValue());
    if (
      form.getFieldValue("name") === "" ||
      form.getFieldValue("name") === undefined ||
      form.getFieldValue("position") === "" ||
      form.getFieldValue("position") === undefined ||
      form.getFieldValue("phones").length === 0 ||
      form.getFieldValue("emails").length === 0
    ) {
      if (
        form.getFieldValue("name") === "" ||
        form.getFieldValue("name") === undefined
      ) {
        form.setFields([
          {
            name: "name",
            errors: ["โปรดระบุ"],
          },
        ]);
      }

      if (
        form.getFieldValue("position") === "" ||
        form.getFieldValue("position") === undefined
      ) {
        form.setFields([
          {
            name: "position",
            errors: ["โปรดระบุ"],
          },
        ]);
      }
      if (form.getFieldValue("phones").length === 0) {
        form.setFields([
          {
            name: "phones",
            errors: ["โปรดระบุ"],
          },
        ]);
      }

      if (form.getFieldValue("emails").length === 0) {
        form.setFields([
          {
            name: "emails",
            errors: ["โปรดระบุ"],
          },
        ]);
      }

      settableAction(false);
    } else {
      const valueData = {
        key: values.key,
        name: form.getFieldValue("name"),
        position: form.getFieldValue("position"),
        phones: form.getFieldValue("phones"),
        emails: form.getFieldValue("emails"),
        favorite : currentRow?.favorite ?? false ,
      };

      const updateData = [...dataSource];

      updateData.splice(editingRow, 1, {
        ...valueData,
        sequence: editingRow + 1,
      });

      setDataSource(updateData);
      setEditingRow(null);
      settableAction(true);
    }
  };
  const getListCompany = async (searchText) => {
      const res = await searchListByCompany(searchText);
      const { objectValue } = res.data;
  
      if (res?.data?.code === "0000") {
        const regularExpressPattern = /^[a-zA-Z0-9\s]+$/;
        const isEn = regularExpressPattern.test(searchText);
        const mapValue = objectValue.map((data, index) => {
          const companyNameEn = _.get(data, "companyNameEn");
          const companyNameTh = _.get(data, "companyNameTh");
  
          return {
            ...data,
            value: isEn ? (companyNameEn || companyNameTh) : (companyNameTh || companyNameEn),
            id: index,
            key: index,
          };
        });
  
        setCompanyAutocomplete(mapValue);
      } else {
        setCompanyAutocomplete([]);
      }
    };
  //END TABLE FUNCTION
  const normalizeChannel = (value) => {
    if (value == null || value === "") return [];          
    if (Array.isArray(value)) return value;                
    return [value];                                        
  };
  let futureCustomerImagePersonal = []
  const onFinish = async (values) => {
    setLoadingBtn(true);
    setResultVOCData([]);
    setContactList([]);
    setTableListData([]);
    let fieldValue = form.getFieldsValue(true);
      console.log("fieldValue.contact :", fieldValue.contact);

    // set contact
    if (fieldValue.contact && fieldValue.contact.length > 0) {
      fieldValue.contact.map((item, index) => {
        contactList.push({
          contactDate: item.date_contact.format(dateFormat),
          officerName: item.name_staff,
          detail: item.detail_contact ? item.detail_contact : "",
          currentStatus: item.currentStatus ? item.currentStatus : "", 
          // using lodash with fileList[index].name
          fileName: _.get(fileList, `[${index}].name`, ""),
          filePath: _.get(fileList, `[${index}].path`, ""),
        });
      });
    }
    
    const lastIndex = contactList.length - 1;
    const latestContact = contactList.reduce((latest, curr) => {
      const c = moment(curr.contactDate, dateFormat, true);
      const l = latest ? moment(latest.contactDate, dateFormat, true) : null;
      
      if (!latest){
         return curr;
      }else{
      return moment(curr.contactDate, dateFormat)
        .isAfter(moment(latest.contactDate, dateFormat))
        ? curr
        : latest;
        }
    }, null);
    let lastStatus = "";
    if (latestContact) {
      lastStatus = latestContact.currentStatus;
    }
    // setCurrentStatus();
    const slot = 0;
    if(fileImageList && fileImageList.length > 0){
      futureCustomerImagePersonal = (fileImageList || [])
      .filter(x => x.slot === slot)  
      .map(({ name, file, path }) => ({
        fileName: name || file || "",  
        filePath: path || ""          
      }));
    }
    //set futureCustomerVoc
    let newData = [
      productRequirement,
      customerSupport,
      customerExpact,
      businessRequire,
      otherProductExpect,
      otherSupportExpect,
      otherBusinessExpect,
      otherExpect,
    ];

    const resultVOC = newData.filter((item) => {
      return item.detail.length > 0;
    });

    dataSource.map((item) => {
      tableListData.push({
        sequence: item.sequence,
        name: item.name,
        position: item.position,
        phones: item.phones,
        emails: item.emails,
        favorite: item.favorite,
      });
    });

    let arrReason = [];
    if (contactReason) {
      for (let a = 0; a < values.topicList.length; a++) {

        arrReason.push({
          topicId: contactReason[a],
          topicOther: (contactReason[a] === "965a18a0-1029-410b-9900-1c1d1c1fea47"
            ? values.topicOther
            : ""),
        });
      }
    }

    if (actionType === "CREATE") {
      //CREATE

      let requestbody = {
        requestObject: {
          dbdRegisterNumber: values.dbdRegisterNumber,
          yearOfBudget: parseInt(yearOfBudget) - 543,
          topicList: arrReason,
          fromDate: valueRange,
          toDate: valueRange,
          // currentStatus: contactList[contactList.length - 1]?.currentStatus ? contactList[contactList.length - 1]?.currentStatus : "",
          currentStatus: lastStatus ? lastStatus : "",
          isInvestmentAdvice:
            fieldValue.isInvestmentAdvice != null
              ? fieldValue.isInvestmentAdvice
              : null,
          isVisitAreaLandInfo:
            fieldValue.isVisitAreaLandInfo != null
              ? fieldValue.isVisitAreaLandInfo
              : null,
          isAskForApprove:
            fieldValue.isAskForApprove != null
              ? fieldValue.isAskForApprove
              : null,
          otherPurposes: values.otherPurposes,
          companyType: companyType,
          companyNameEn: values.companyNameEn,
          companyNameTh: values.companyNameTh,
          address: values.address,
          website: values.website,
          nationalIds: nationalIds,
          currentIndustry: values.currentIndustry,
          ieatIndusrty: values.ieatIndusrty,
          industryTypeIds: industryTypeIds,
          investmentAmount: fieldValue.investmentAmount
            ? parseFloat(fieldValue.investmentAmount)
            : 0.0,
          areaTypeIds: areaTypeIds,
          estateTypeIds : estateTypeIds,
          regionTypeIds : regionTypeIds,

          areaSizeRai: fieldValue.areaSizeRai
            ? parseFloat(fieldValue.areaSizeRai)
            : 0.0,
          areaSizeNgan: fieldValue.areaSizeNgan
            ? parseFloat(fieldValue.areaSizeNgan)
            : 0.0,
          areaSizeWa: fieldValue.areaSizeWa
            ? parseFloat(fieldValue.areaSizeWa)
            : 0.0,
          areaSizeMeter: fieldValue.areaSizeMeter
            ? parseFloat(fieldValue.areaSizeMeter)
            : 0.0,
          areaSizeRecommend: fieldValue.areaSizeRecommend
            ? parseFloat(fieldValue.areaSizeRecommend)
            : 0.0,

          waterConsumptionAmount: fieldValue.waterConsumptionAmount
            ? parseFloat(fieldValue.waterConsumptionAmount)
            : 0.0,
          wasteWaterAmount: fieldValue.wasteWaterAmount
            ? parseFloat(fieldValue.wasteWaterAmount)
            : 0.0,
          untreatedWaterAmount: fieldValue.untreatedWaterAmount
            ? parseFloat(fieldValue.untreatedWaterAmount)
            : 0.0,
          kwAmount: fieldValue.kwAmount ? parseFloat(fieldValue.kwAmount) : 0.0,
          futureCustomerMembers: tableListData,
          futureCustomerVoc: resultVOC,
          fileName: _.get(fileList, `[0].name`, ""),
          pathName: _.get(fileList, `[0].path`, ""),
          futureCustomerBehavior: [
            {
              customerBehavior: values.customer_behavior
                ? values.customer_behavior
                : "",
              channel: normalizeChannel(behaviorChannel),
              suggestion: values.suggestion,
            },
          ],
          futureCustomerContacts: contactList,
          futureCustomerImagePersonal: futureCustomerImagePersonal,
        },
      };
      console.log("requestbody: ",requestbody)
      // console.log("CREATE", requestbody);
      try {
        const res = await createFutureCustomer(requestbody);
        console.log("requestbody: ",requestbody)

        if (res.data.code === "0000") {
          setSuccessModal(true);
          setTimeout(() => {
            navigate(routes.customer_tab_future, {
              state: {},
            });
          }, 1000);
        } else {
          if (res.data.code === "ERR-0022") {
            form.setFields([
              {
                name: "dbdRegisterNumber",
                errors: [
                  "เลข DBD Register number นี้มีอยู่ในระบบแล้วกรุณาตรวจสอบข้อมูล",
                ],
              },
            ]);
            setFailModal(true);
          } else {
            setFailModal(true);
          }
        }

        setLoadingBtn(false);
      } catch (error) {
        setLoadingBtn(false);
      }
    } else {
      //EDIT

      if (
        fieldValue.productRequirement != undefined &&
        fieldValue.productRequirement.length > 0
      ) {
        resultVOCData.push({
          type: "product_requirement",
          detail: fieldValue.productRequirement,
        });
      }

      if (
        fieldValue.customerSupport != undefined &&
        fieldValue.customerSupport.length > 0
      ) {
        resultVOCData.push({
          type: "customer_support",
          detail: fieldValue.customerSupport,
        });
      }

      if (
        fieldValue.businessRequire != undefined &&
        fieldValue.businessRequire.length > 0
      ) {
        resultVOCData.push({
          type: "business_require",
          detail: fieldValue.businessRequire,
        });
      }

      if (
        fieldValue.customerExpact != undefined &&
        fieldValue.customerExpact.length > 0
      ) {
        resultVOCData.push({
          type: "customer_expect",
          detail: fieldValue.customerExpact,
        });
      }

      if (
        fieldValue.otherProductExpect != undefined &&
        fieldValue.otherProductExpect.length > 0
      ) {
        resultVOCData.push({
          type: "other_product_expect",
          detail: fieldValue.otherProductExpect,
        });
      }

      if (
        fieldValue.otherSupportExpect != undefined &&
        fieldValue.otherSupportExpect.length > 0
      ) {
        resultVOCData.push({
          type: "other_support_expect",
          detail: fieldValue.otherSupportExpect,
        });
      }

      if (
        fieldValue.otherBusinessExpect != undefined &&
        fieldValue.otherBusinessExpect.length > 0
      ) {
        resultVOCData.push({
          type: "other_business_expect",
          detail: fieldValue.otherBusinessExpect,
        });
      }

      if (
        fieldValue.otherExpect != undefined &&
        fieldValue.otherExpect != "" &&
        fieldValue.otherExpect.length > 0
      ) {
        resultVOCData.push({
          type: "other_expect",
          detail: Array.isArray(fieldValue.otherExpect) ? fieldValue.otherExpect : [fieldValue.otherExpect],
        });
      }

      let chkStatus = convertMasterData(currentStatus, dropDownCurerntStatus);

     if ((contactReason === null || contactReason === undefined) && values.topicList?.length > 0) {
        for (const element of values.topicList) {
          arrReason.push({
            topicId: element,
            topicOther: (element === "965a18a0-1029-410b-9900-1c1d1c1fea47" ? values.topicOther : ""),
          })
        }
      }

      const dateRange = valueRange === null || valueRange === '' ? dateFrom : valueRange;

      let requestbody = {
        requestObject: {
          futureCustomerId: id,
          dbdRegisterNumber: values.dbdRegisterNumber,
          yearOfBudget: parseInt(yearOfBudget) - 543,
          topicList: arrReason,
          fromDate: dateRange,
          toDate: dateRange,
          // currentStatus: contactList[contactList.length - 1]?.currentStatus ? contactList[contactList.length - 1]?.currentStatus : "",
          currentStatus: lastStatus ? lastStatus : "",
          isToCurrentCustomer:
            chkStatus === "ปิดการขาย (ส่งสู่ลูกค้าปัจจุบัน)" ? true : false,
          isInvestmentAdvice:
            fieldValue.isInvestmentAdvice != null
              ? fieldValue.isInvestmentAdvice
              : null,
          isVisitAreaLandInfo:
            fieldValue.isVisitAreaLandInfo != null
              ? fieldValue.isVisitAreaLandInfo
              : null,
          isAskForApprove:
            fieldValue.isAskForApprove != null
              ? fieldValue.isAskForApprove
              : null,
          otherPurposes: values.otherPurposes,
          companyType: companyType,
          companyNameEn: values.companyNameEn,
          companyNameTh: values.companyNameTh,
          address: values.address,
          website: values.website,
          nationalIds: nationalIds,
          currentIndustry: values.currentIndustry,
          ieatIndusrty: values.ieatIndusrty,
          industryTypeIds: industryTypeIds,
          fileName: _.get(fileList, `[0].name`, ""),
          pathName: _.get(fileList, `[0].path`, ""),
          investmentAmount: fieldValue.investmentAmount
            ? parseFloat(fieldValue.investmentAmount)
            : 0.0,
          
          areaTypeIds: areaTypeIds,
          estateTypeIds : estateTypeIds,
          regionTypeIds : regionTypeIds ,

          areaSizeRai: fieldValue.areaSizeRai
            ? parseFloat(fieldValue.areaSizeRai)
            : 0.0,
          areaSizeNgan: fieldValue.areaSizeNgan
            ? parseFloat(fieldValue.areaSizeNgan)
            : 0.0,
          areaSizeWa: fieldValue.areaSizeWa
            ? parseFloat(fieldValue.areaSizeWa)
            : 0.0,
          areaSizeMeter: fieldValue.areaSizeMeter
            ? parseFloat(fieldValue.areaSizeMeter)
            : 0.0,
          areaSizeRecommend: fieldValue.areaSizeRecommend
            ? parseFloat(fieldValue.areaSizeRecommend)
            : 0.0,
          waterConsumptionAmount: fieldValue.waterConsumptionAmount
            ? parseFloat(fieldValue.waterConsumptionAmount)
            : 0.0,
          wasteWaterAmount: fieldValue.wasteWaterAmount
            ? parseFloat(fieldValue.wasteWaterAmount)
            : 0.0,
          untreatedWaterAmount: fieldValue.untreatedWaterAmount
            ? parseFloat(fieldValue.untreatedWaterAmount)
            : 0.0,
          kwAmount: fieldValue.kwAmount ? parseFloat(fieldValue.kwAmount) : 0.0,
          futureCustomerMembers: tableListData,
          futureCustomerVoc: resultVOCData,
          futureCustomerBehavior: [
            {
              customerBehavior: values.customer_behavior
                ? values.customer_behavior
                : "",
              channel: normalizeChannel(behaviorChannel),
              suggestion: values.suggestion ? values.suggestion : "",
            },
          ],
          futureCustomerContacts: contactList,
          futureCustomerImagePersonal: futureCustomerImagePersonal,
        },
      };

      // console.log("EDIT", requestbody);
      try {
        console.log("requestbody: ",requestbody)

        const res = await updateFutureCustomer(requestbody);
        if (res.data.code === "0000") {
          setSuccessModal(true);
          setTimeout(() => {
            navigate(routes.customer_tab_future, {
              state: {},
            });
          }, 1000);
        } else {
          if (res.data.code === "ERR-0022") {
            form.setFields([
              {
                name: "dbdRegisterNumber",
                errors: [
                  "เลข DBD Register number นี้มีอยู่ในระบบแล้วกรุณาตรวจสอบข้อมูล",
                ],
              },
            ]);
            setFailModal(true);
          } else {
            setFailModal(true);
          }
        }

        setLoadingBtn(false);
      } catch (error) {
        //  console.log(error);

        setLoadingBtn(false);
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    // Get the name of the first field with an error
    const firstErrorField = errorInfo.errorFields[0].name;

    let fieldId = Array.isArray(firstErrorField) ? firstErrorField.join('_') : firstErrorField;
    fieldId = fieldId + "_help";

    // Get a reference to the DOM element of that field
    const errorFieldElement = document.getElementById(fieldId);

    if (errorFieldElement) {
      // Scroll to the element
      errorFieldElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center', // Scrolls the element to the center of the view
      });
    }
  };

  const onDefaultChange = (value, field) => {
    if (value && value <= 999999999999.99) {
      form.setFields([
        {
          name: field,
          value: onDecimalChange(value),
        },
      ]);
    }
  };

  //UPLOAD FILE

  const props = {
    beforeUpload: (file) => {
      const allowType =
        // file.type === "image/png" ||
        file.type === "image/jpeg" || file.type === "application/pdf";
      if (!allowType) {
        message.error(`${file.name} is not a  JPG, PDF file`);
      }
      return allowType || Upload.LIST_IGNORE;
    },
    onChange: (info) => {
      // console.log("info.fileList :: ", info.fileList);
    },
  };

  const onRemoveFile = (info, index) => {
    console.log("onRemove info = " + info.file);
    console.log("onRemove index = " + index);
    form.setFields([
      {
        name: ["filePath", index],
        value: "",
      },
    ]);
    let newData = fileList.filter((item) => item.index !== index);
    setFileList(newData);
  };
  const onRemoveImageFile = (file, slotIndex) => {

  setFileImageList(prev =>
    prev.filter(it => !(it.index === slotIndex && it.uid === file.uid))
  );

  const remainPaths = fileImageList
    .filter(it => !(it.index === slotIndex && it.uid === file.uid)) 
    .filter(it => it.index === slotIndex)
    .map(it => it.path);

  form.setFields([
    { name: ["filePath", slotIndex], value: remainPaths, errors: [] },
  ]);

  // 3) (ทางเลือก) return true เพื่อให้ antd ลบจาก UI ด้วย
  return true;
};
  const normalizeContentType = (obj) => {
  let t = obj?.headers?.["Content-Type"] ?? obj?.headers?.["content-type"] ?? "";
  if (Array.isArray(t)) t = t[0];
  t = String(t || "").toLowerCase();
  if (!t || t === "application/octet-stream") {
    const n = (obj?.fileName || "").toLowerCase();
    if (n.endsWith(".jpg") || n.endsWith(".jpeg")) return "image/jpeg";
    if (n.endsWith(".png")) return "image/png";
    if (n.endsWith(".pdf")) return "application/pdf";
  }
  return t || "image/jpeg";
};


  const [thumbs, setThumbs] = useState({});
  const slotIndex = 0; 

  // เฉพาะรายการของ index นี้
  const items = useMemo(
    () => (fileImageList || []).filter((x) => x.index === slotIndex),
    [fileImageList, slotIndex]
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      for (const it of items) {
        if (thumbs[it.path]) continue;  // มีแล้วข้าม
        try {
          const res = await downloadFile(it.path);
          const { objectValue } = res?.data || {};
          if (!objectValue?.bytes) continue;
          const type = normalizeContentType(objectValue);
          if (type === "application/pdf") {
            // PDF ไม่ทำรูป thumb, ให้พรีวิวตอนกดดู
            setThumbs((p) => ({ ...p, [it.path]: { src: "", isPdf: true, title: objectValue.fileName || it.fileName } }));
            continue;
          }
          const src = bytesToDataUrl(objectValue.bytes, type);
          if (!cancelled) {
            setThumbs((p) => ({ ...p, [it.path]: { src, isPdf: false, title: objectValue.fileName || it.fileName } }));
          }
        } catch {
          /* เงียบไว้ แสดง skeleton แทน */
        }
      }
    })();
    return () => { cancelled = true; };
  }, [items]);
  // state ไว้เก็บผลอัปโหลดทั้งหมด
    const [uploads, setUploads] = useState([]); 
    // uploads = [{ index: 0, fileName: 'a.png', filePath: '...'}, { index: 1, ... }]

    // helper: อัปเดต/แทนที่ตาม index
    const upsertUpload = (idx, fileName, filePath) => {
    setUploads(prev => {
        const existIdx = prev.findIndex(x => x.index === idx);
        const row = { index: idx, fileName, filePath };
        if (existIdx >= 0) {
        const next = prev.slice();
        next[existIdx] = row;
        return next;
        }
        return [...prev, row];
    });
    };

    // ดึง array เฉพาะ filePath (ไว้ส่งต่อ/บันทึก)
    const getAllFilePaths = () => uploads.map(x => x.filePath).filter(Boolean);
    // ดึง array ของ {fileName,filePath}
    const getAllFiles = () => uploads.map(({fileName, filePath}) => ({fileName, filePath}));
    // const onUploadFile = async (info, index) => {
    // const newObj = {
    //     index,
    //     file: info.file.name,
    //     name: info.file.name,
    //     status: "uploading",
    //     uid: info.file.uid,
    //     url: "",
    //     path: "",
    // };

    // const formData = new FormData();
    // formData.append("file", info.file);

    // const api = APIEndpoint.UPLOAD_FILE_API;
    // const config = {
    //     headers: {
    //     Authorization: `Bearer ${localStorage.getItem("ACCESS_TOKEN")}`,
    //     "content-type": "multipart/form-data",
    //     },
    // };

    // const res = await axios.post(APPCONFIG.GATEWAY_ENDPOINT + api, formData, config);

    // if (res?.data?.code === SUCCESS_CODE) {
    //     message.success(`${res.data.message}`);
    //     const { objectValue } = res.data;

    //     newObj.status = "done";
    //     newObj.file = objectValue.fileName;
    //     newObj.name = objectValue.fileName;
    //     newObj.path = objectValue.filePath;

    //     // === เพิ่มแค่บรรทัดนี้เพื่อเก็บ array ===
    //     upsertUpload(index, objectValue.fileName, objectValue.filePath);

    //     // ของเดิมคุณ
    //     if (fileList.length === 0) {
    //     setFileList([newObj]);
    //     } else {
    //     const newData = fileList.filter((item) => item.index !== index);
    //     newData.push(newObj);
    //     setFileList(newData);
    //     }
    //     form.setFields([
    //     { name: ["filePath", index], value: objectValue.filePath, errors: [] },
    //     ]);

    //     return newObj;
    // } else {
    //     newObj.status = "error";
    //     message.error(`${res.data.message}`);
    // }
    // };

  const beforeUpload = (file) => {
    const okType = ["image/jpeg", "image/jpg", "application/pdf"].includes(file.type);
    if (!okType) {
      message.error("รองรับไฟล์ JPG/JPEG และ PDF เท่านั้น");
      return Upload.LIST_IGNORE;
    }
    const sizeOk = file.size / 1024 / 1024 <= 50;
    if (!sizeOk) {
      message.error("ขนาดไฟล์ต้องไม่เกิน 50 MB");
      return Upload.LIST_IGNORE;
    }
    return true;
  };
  const onPreviewFile = async (filePath) => {
    try {
      const res = await downloadFile(filePath);
      const { objectValue } = res.data || {};
      if (!objectValue?.bytes) throw new Error("no bytes");

      let type = objectValue.headers?.["Content-Type"]?.[0] || "application/octet-stream";
      // เผื่อเคส octet-stream แต่ชื่อ .pdf
      if (type === "application/octet-stream" && objectValue.fileName?.toLowerCase().endsWith(".pdf")) {
        type = "application/pdf";
      }
      const src = bytesToDataUrl(objectValue.bytes, type);
      setPreview({ visible: true, src, isPdf: type === "application/pdf", title: objectValue.fileName || "Preview" });
      console.log(preview);
    } catch (e) {
      console.error(e);
      message.error("ไม่สามารถพรีวิวไฟล์ได้");
    }
  };
  const bytesToDataUrl = (bytes, contentType) => {
    // API เดิมคืน base64 อยู่แล้วใน objectValue.bytes (จากโค้ดที่คุณโชว์ก่อนหน้า)
    const base64 = Array.isArray(bytes)
      ? btoa(String.fromCharCode(...bytes))
      : bytes;
    return `data:${contentType};base64,${base64}`;
  };
  const onUploadFile = async (info, index) => {
    const newObj = {
      index: index,
      file: info.file.name,
      name: info.file.name,
      status: "uploading",
      uid: info.file.uid,
      url: "",
      path: "",
    };

    let formData = new FormData();
    formData.append("file", info.file);

    const api = APIEndpoint.UPLOAD_FILE_API;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        "content-type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      APPCONFIG.GATEWAY_ENDPOINT + api,
      formData,
      config
    );
    if (res?.data?.code === SUCCESS_CODE) {
      message.success(`${res.data.message}`);
      const { objectValue } = res.data;
      newObj.status = "done";
      newObj.file = objectValue.fileName;
      newObj.name = objectValue.fileName;
      newObj.path = objectValue.filePath;

      if (fileList.length === 0) {
        setFileList([newObj]);
      } else {
        let newData = fileList.filter((item) => item.index !== index);
        newData.push(newObj);
        setFileList(newData);
      }

      form.setFields([
        {
          name: ["filePath", index],
          value: objectValue.filePath,
          errors: [],
        },
      ]);
    } else {
      newObj.status = "error";
      // console.log("newObj err", newObj);
      // console.log("err: ", res.data.code, res.data.message);
      message.error(`${res.data.message}`);
    }
  };
  const hydrateImages = (serverList = [], slotIndex = 0) => {
  return serverList.map((it, i) => ({
    index: slotIndex,
    slot: slotIndex,
    uid: it.imagePersonalId || `${slotIndex}-${i}`,
    status: 'done',
    file: it.fileName,          
    name: it.fileName,          
    fileName: it.fileName,      
    path: it.filePath,          
    url: '',                    
  }));
};
  const onUploadImageFile = async (info,slot ) => {
    const newObj = {
      index: slot,
      slot,
      file: info.file.name,
      name: info.file.name,
      status: "uploading",
      uid: info.file.uid,
      url: "",
      path: "",
    };

    let formData = new FormData();
    formData.append("file", info.file);

    const api = APIEndpoint.UPLOAD_FILE_API;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        "content-type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      APPCONFIG.GATEWAY_ENDPOINT + api,
      formData,
      config
    );
    if (res?.data?.code === SUCCESS_CODE) {
      message.success(`${res.data.message}`);
      const { objectValue } = res.data;
      newObj.status = "done";
      newObj.file = objectValue.fileName;
      newObj.name = objectValue.fileName;
      newObj.path = objectValue.filePath;
  //       setFileImageList(prev => {
  //   const next = prev.filter(item => item.index !== index);
  //   next.push(newObj);
  //   console.log('next fileImageList:', next);
  //   return next;
  // });
 setFileImageList(prev => {
      const next = prev.filter(it => !(it.slot === slot && it.uid === newObj.uid));
      next.push(newObj);
      return next;
    });
      // if (fileImageList.length === 0) {
      //   setFileImageList([newObj]);
      //   console.log(objectValue)

      // } else {
      //   let newData = fileImageList.filter((item) => item.index !== index);
      //   newData.push(newObj);
      //   setFileImageList(newData);
      // }
      form.setFields([
        {
          name: ["filePath", slot],
          // name: ["filePath", index],
          value: objectValue.filePath,
          errors: [],
        },
      ]);
    } else {
      newObj.status = "error";
      // console.log("newObj err", newObj);
      // console.log("err: ", res.data.code, res.data.message);
      message.error(`${res.data.message}`);
    }
  };
  const CalMonth = (dateString) => {
    const d_now = new Date();
    const getDate = (date) => moment(date, "DD/MM/YYYY").startOf("month");
    const diff = Math.abs(getDate(dateString).diff(getDate(d_now), "months"));

    return diff;
  };

  const getDetail = useCallback(async () => {
    const res = await getFutureCustomer(id);

    // setResultVOCData([]);
    if (res.data.code === "0000") {
      let result_data = res.data.objectValue;
      setDataDetail(result_data);
      console.log("getDetailEDIT=>", result_data);

      let addKey = result_data.futureCustomerMembers.map((x, i) => ({
        ...x,
        key: i,
        favorite: x.favorite ? x.favorite: false,
        
      }));
      console.log('addKey',addKey);
      const product_requirement = result_data.futureCustomerVoc.filter(
        (word) => word.type === "product_requirement"
      );
      const customer_support = result_data.futureCustomerVoc.filter(
        (word) => word.type === "customer_support"
      );
      const business_require = result_data.futureCustomerVoc.filter(
        (word) => word.type === "business_require"
      );
      const customer_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "customer_expect"
      );
      const other_product_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_product_expect"
      );
      const other_support_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_support_expect"
      );
      const other_business_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_business_expect"
      );
      const other_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_expect"
      );
      const hydrated = hydrateImages(result_data.futureCustomerImagePersonal || [], slotIndex);

      setYearOfBudget(parseInt(result_data.yearOfBudget) + 543);
      setCurrentStatus(result_data.currentStatus);
      setCompanyType(result_data.companyType);
      setNationalIds(result_data.nationalIds);
      setIndustryTypeIds(result_data.industryTypeIds);
      setAreaTypeIds(result_data.areaTypeIds);
      setEstateTypeIds(result_data.estateTypeIds);
      setRegionTypeIds(result_data.regionTypeIds);

      setBehaviorChannel(
        result_data.futureCustomerBehavior.length > 0
          ? result_data.futureCustomerBehavior[0].channel
          : []
      );
      setFileImageList(prev => {
      const others = prev.filter(x => x.index !== slotIndex);
      return [...others, ...hydrated];
      });
      form.setFields([
        { name: ['filePath', slotIndex], value: hydrated.map(x => x.path), errors: [] },
      ]);
      setDateFrom(result_data.fromDate);
      setDateTo(result_data.toDate);
      setDataSource(addKey);
      settableAction(true);
      setActionName("แก้ไขข้อมูล");
      setCounthMonth(CalMonth(result_data.fromDate));

      result_data.futureCustomerContacts.map((item, index) => {
        const newObj = {
          index: index,
          file: item.fileName,
          name: item.fileName,
          status: "done",
          uid: item.contactId,
          url: "",
          path: item.filePath,
          msg: "",
        };
        fileList.push(newObj);
      });
      // loop over result_data.topicList and create array of topicId
      let topicOther = null;
      let arrReason = [];
      if (result_data.topicList) {
        for (let a = 0; a < result_data.topicList.length; a++) {
          arrReason.push(result_data.topicList[a].topicId);
          if(topicOther==null && result_data.topicList[a].topicId === "965a18a0-1029-410b-9900-1c1d1c1fea47"){
            topicOther = result_data.topicList[a].topicOther;
            setOtherTopicDefined(true);
          }
        }
      }

      form.setFieldsValue({
        futureCustomerId: id,
        dbdRegisterNumber: result_data.dbdRegisterNumber,
        yearOfBudget: parseInt(result_data.yearOfBudget) + 543,
        topicList: arrReason,
        topicOther: topicOther,
        dateFromTo: moment(result_data.fromDate, dateFormat),
        isAskForApprove: result_data.isAskForApprove,
        isInvestmentAdvice: result_data.isInvestmentAdvice,
        isVisitAreaLandInfo: result_data.isVisitAreaLandInfo,
        currentStatus: result_data.currentStatus,
        otherPurposes: result_data.otherPurposes,
        companyType: result_data.companyType,
        companyNameEn: result_data.companyNameEn,
        companyNameTh: result_data.companyNameTh,
        address: result_data.address,
        website: result_data.website,
        nationalIds: result_data.nationalIds,
        ieatIndusrty: result_data.ieatIndusrty,
        currentIndustry: result_data.currentIndustry,
        industryTypeIds: result_data.industryTypeIds,
        investmentAmount: result_data.investmentAmount
          ? result_data.investmentAmount
          : "",
        areaTypeIds: result_data.areaTypeIds ? result_data.areaTypeIds : "",
        estateTypeIds: result_data.estateTypeIds ? result_data.estateTypeIds : "",
        regionTypeIds : result_data.regionTypeIds ? result_data.regionTypeIds : "",

        areaSizeRai: result_data.areaSizeRai ? result_data.areaSizeRai : "",
        areaSizeNgan: result_data.areaSizeNgan ? result_data.areaSizeNgan : "",
        areaSizeWa: result_data.areaSizeWa ? result_data.areaSizeWa : "",
        areaSizeMeter: result_data.areaSizeMeter
          ? result_data.areaSizeMeter
          : "",
        areaSizeRecommend: result_data.areaSizeRecommend
          ? result_data.areaSizeRecommend
          : "",
        waterConsumptionAmount: result_data.waterConsumptionAmount
          ? result_data.waterConsumptionAmount
          : "",
        wasteWaterAmount: result_data.wasteWaterAmount
          ? result_data.wasteWaterAmount
          : "",
        untreatedWaterAmount: result_data.untreatedWaterAmount
          ? result_data.untreatedWaterAmount
          : "",
        kwAmount: result_data.kwAmount ? result_data.kwAmount : "",
        productRequirement:
          product_requirement.length > 0
            ? product_requirement[0].detail
            : undefined,
        customerSupport:
          customer_support.length > 0 ? customer_support[0].detail : undefined,
        businessRequire:
          business_require.length > 0 ? business_require[0].detail : undefined,
        customerExpact:
          customer_expect.length > 0 ? customer_expect[0].detail : undefined,
        otherProductExpect:
          other_product_expect.length > 0
            ? other_product_expect[0].detail
            : undefined,
        otherSupportExpect:
          other_support_expect.length > 0
            ? other_support_expect[0].detail
            : undefined,
        otherBusinessExpect:
          other_business_expect.length > 0
            ? other_business_expect[0].detail
            : undefined,
        otherExpect:
          other_expect.length > 0 ? other_expect[0].detail : undefined,
        customer_behavior:
          result_data.futureCustomerBehavior.length > 0
            ? result_data.futureCustomerBehavior[0].customerBehavior
            : "",
        dropDownKnowChannel:
          result_data.futureCustomerBehavior.length > 0 &&
          result_data.futureCustomerBehavior[0].channel != ""
            ? result_data.futureCustomerBehavior[0].channel
            : undefined,
        other_detail:
          result_data.futureCustomerBehavior.length > 0
            ? result_data.futureCustomerBehavior[0].suggestion
            : "",
      });

      let newValue = [];

      result_data.futureCustomerContacts.map((item,k) => {
        newValue.push({
          contact_no: k + 1,
          date_contact: moment(item.contactDate, dateFormat),
          name_staff: item.officerName,
          detail_contact: item.detail,
          currentStatus : item.currentStatus,
        });
      });
      form.setFieldsValue({
        contact: newValue,
      });
      console.log("form => ", form.getFieldsValue(true));
    }
  }, [form]);

  useEffect(() => {
    getCountry();
    masterDataFuture.map((item) => {
      getMaster(item);
    });
    vocDataFuture.map((item) => {
      getVOC(item);
    });

    if (actionType === "EDIT") {
      setActionName("แก้ไขข้อมูล");

      getDetail();
    } else {
      setActionName("เพิ่มข้อมูล");
      form.resetFields();
    }
  }, [location]);


  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_future);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={actionName} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลลูกค้าอนาคต ",
                },
                {
                  title: (
                    <span onClick={onChangePage} style={{ cursor: "pointer" }}>
                      ข้อมูลลูกค้าอนาคต
                    </span>
                  ),
                },
                {
                  title: <span className="pr_green">{actionName}</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError={{ behavior: 'smooth' }}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.customer_tab_future);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      // disabled={!submittable}
                      // loading={loading}
                      loading={loadingBtn}
                    >
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>
              {/* Future Deatil */}
              <FutureDetail
                dropDownContactReason={dropDownContactReason}
                getYearDropdown={yearList}
                dropDownAreaType={dropDownAreaType}
                dropDownCompanyType={dropDownCompanyType}
                dropDownCurerntStatus={dropDownCurerntStatus}
                dropDownIndustryType={dropDownIndustryType}
                dropDownPurpost={dropDownPurpost}
                dropDownRegionGroup={dropDownRegionGroup}
                dropDownRegionType={dropDownRegionType}
                dropDownCountry={dropDownCountry}
                dropDownFutureEstate= {dropDownFutureEstate}
                setDatesRange={setDatesRange}
                setValueRange={setValueRange}
                valueRange={valueRange}
                datesRange={datesRange}
                getListCompany= {getListCompany}
                companyAutocomplete = {companyAutocomplete}
                records = {records}
                setRecords = {setRecords}
                handleFavorite = {handleFavorite}
                
                onChangesetYearOfBudget={onChangesetYearOfBudget}
                onChangeContactReason={onChangeContactReason}
                onChangeCurrentStatus={onChangeCurrentStatus}
                onDefaultChange={onDefaultChange}
                onChangeCompanyType={onChangeCompanyType}
                onChangeIndustryTypeIds={onChangeIndustryTypeIds}
                onChangeNationalIds={onChangeNationalIds}
                onChangeAreaTypeIds={onChangeAreaTypeIds}
                onChangeFutureEstate = {onChangeFutureEstate}
                onChangeRegionType = {onChangeRegionType}

                onRemoveImageFile={onRemoveImageFile}
                onUploadImageFile={onUploadImageFile}
                fileImageList={fileImageList}
                setFileImageList={setFileImageList}
                onPreviewFile={onPreviewFile}
                preview={preview}
                setPreview={setPreview}
                slotIndex = {slotIndex}
                items = {items}
                thumbs = {thumbs}
                //TABLE
                dataSource={dataSource}
                editingRow={editingRow}
                handleAdd={handleAdd}
                handleEdit={handleEdit}
                onSaveTable={onSaveTable}
                handleDeleteReccord={handleDeleteReccord}
                statusBT={statusBT}
                tableAction={tableAction}
                countMonth={countMonth}
                setCounthMonth={setCounthMonth}
                onCalculatorMonth={onCalculatorMonth}
                otherTopicDefined={otherTopicDefined}
              />

              {/* Voice of Customer */}
              <VoiceOfCustomer
                dropDownproductRequirement={dropDownproductRequirement}
                dropDowncustomerSupport={dropDowncustomerSupport}
                dropDowncustomerExpact={dropDowncustomerExpact}
                dropDownbusinessRequire={dropDownbusinessRequire}
                dropDownotherProductExpect={dropDownotherProductExpect}
                dropDownotherSupportExpect={dropDownotherSupportExpect}
                dropDownotherBusinessExpect={dropDownotherBusinessExpect}
                handleOnChangeVOC={handleOnChangeVOC}
              />
              {/* Behavior */}
              <Behavior
                actionType={actionType}
                channel = {channel}
                dropDownKnowChannel={dropDownKnowChannel}
                handleOnChangeVOC={handleOnChangeVOC}
                setBehaviorChannel ={setBehaviorChannel}
              />
              {/* Contact */}
              <Contact
                actionType={actionType}
                props={props}
                onRemoveFile={onRemoveFile}
                onUploadFile={onUploadFile}
                fileList={fileList}
                setFileList={setFileList}
                onChangeCurrentStatus={onChangeCurrentStatus}
                dropDownCurerntStatus={dropDownCurerntStatus}

              />
            </Form>
          </Col>
        </Row>
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        open={failModal}
        setOpen={setFailModal}
        title={"มีบางอย่างผิดพลาด"}
        subTitle={"มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง"}
        setErrMsg={() => setFailModal(false)}
      />

      <FloatButton.BackTop
        className="custom-float-btn"
        icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
        shape="square"
        style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
      />
    </WithSidebar>
  );
};
